import { draftsApi } from './drafts';

export const getDraftsApi = draftsApi.injectEndpoints({
  endpoints: (builder) => ({

    // GET /v2/v2/drafts/business/{businessId}?status=pending_approval
    getDrafts: builder.query({
      query: ({ businessId, status = 'pending_approval' }) =>
        `/business/${businessId}?status=${status}`,
      providesTags: (result, error, { businessId, status }) => [
        { type: 'Drafts', id: `${businessId}-${status}` }
      ],
    }),

    // POST /v2/v2/drafts/{draftId}/approve
    approveDraft: builder.mutation({
      query: ({ draftId, scheduledAt }) => ({
        url: `/${draftId}/approve`,
        method: 'POST',
        body: scheduledAt ? { scheduledAt } : {},
      }),
      invalidatesTags: (result, error, { businessId }) => [
        { type: 'Drafts', id: `${businessId}-pending_approval` },
        { type: 'Drafts', id: `${businessId}-scheduled` },
      ],
    }),

    // POST /v2/v2/drafts/{draftId}/reject
    rejectDraft: builder.mutation({
      query: ({ draftId }) => ({
        url: `/${draftId}/reject`,
        method: 'POST',
        body: {},
      }),
      invalidatesTags: (result, error, { businessId }) => [
        { type: 'Drafts', id: `${businessId}-pending_approval` },
        { type: 'Drafts', id: `${businessId}-rejected` },
      ],
    }),

    // PUT /v2/v2/drafts/{draftId}/edit
    // Editing is NOT reviewing: the draft stays pending_approval. Edit
    // distance is measured at approval time by captureOwnerSignal, so
    // multiple edits collapse into one honest M6 measurement.
    editDraft: builder.mutation({
      query: ({ draftId, editedContent }) => ({
        url: `/${draftId}/edit`,
        method: 'PUT',
        body: { editedContent },
      }),
      // Deliberately NOT invalidating: getDrafts polls every 30s and a
      // refetch replaces the whole array, which would churn cards while
      // an editor is open. Patch the one field in place instead.
      async onQueryStarted(
        { draftId, businessId, status = 'pending_approval', editedContent },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            getDraftsApi.util.updateQueryData(
              'getDrafts',
              { businessId, status },
              (cache) => {
                const d = cache.drafts?.find(x => x._id === draftId);
                if (!d) return;
                if (data.edited) {
                  d.editedContent = editedContent;
                  d.editedAt = new Date().toISOString();
                } else {
                  // server saw the original text and unset the edit
                  delete d.editedContent;
                  delete d.editedAt;
                }
              }
            )
          );
        } catch {
          // request failed — leave cache untouched; the component surfaces
          // the error via unwrap()
        }
      },
    }),

  }),
  overrideExisting: false,
});

export const {
  useGetDraftsQuery,
  useApproveDraftMutation,
  useRejectDraftMutation,
  useEditDraftMutation,
} = getDraftsApi;